import styled from 'styled-components';
import {
  Text,
  InputField,
  InputWithAction,
  Space,
} from '@cashfree-intl/coherent';

export const StyledDivider = styled.div`
  background: #e6e5e8;
  height: 1px;
  margin: 1rem 0;
`;

export const StyledFieldWrapper = styled.div`
  padding: 1rem 0.75rem;
  border-radius: 0.25rem;
  &.selected {
    background: #f6f1ff;
  }
  .h18 {
    font-size: 1.125rem;
  }
  .refund-speed-radio {
    .ui.radio.checkbox {
      label {
        font-size: 1.125rem;
        font-style: normal;
        color: var(--SECONDARY_DARK);
      }
      &.checked {
        label {
          font-weight: 600;
        }
      }
    }
  }
  .link-cta {
    margin-top: 0.75rem;
  }
  .margin-left-30 {
    margin-left: 1.875rem;
    &.instant-refunds {
      margin-top: 0.75rem;
    }
  }
  .left-align {
    margin-left: -1.875rem;
  }
  .ui.radio.checkbox label:after {
    top: 1px;
    left: 0;
  }
  .vendorNameField .ui.fluid.input {
    margin-bottom: 0 !important;
  }
  .optional-label {
    padding: 0.125rem 0.5rem;
    background: var(--TABLE_COLUMN);
    border-radius: 0.125rem;
  }
  .remark-cta {
    min-width: unset;
  }
`;

// const InputWithActionComponent = React.forwardRef(({ className }, ref) => (
//   <InputWithAction ref={ref} className={className} />
// ));

export const StyledInputWithAction = styled(InputWithAction)`
  &.input-with-action {
    max-width: 22.5rem;
    .ui.label {
      border-top-left-radius: 0.375rem;
      border-bottom-left-radius: 0.375rem;
    }
    input {
      border-top-right-radius: 0.375rem;
      border-bottom-right-radius: 0.375rem;
    }
    .info.pointer {
      position: relative;
      right: 1.75rem;
      top: 0.5625rem;
    }
    &.error {
      div,
      input {
        border-color: rgb(203, 44, 44) !important;
        &:focus {
          border-color: rgb(203, 44, 44) !important;
        }
      }
    }
  }
`;

export const StandardSpeedSection = styled.div`
  border-radius: 0.125rem;
  background: #fff4df;
  padding: 0.25rem;
  .h10 {
    font-size: 0.625rem;
  }
  img {
    width: 0.75rem;
    height: 0.75rem;
  }
`;

export const TextNote = styled(Text)`
  font-family: 'dm-sans';
  font-weight: 500;
  margin-top: 0.5rem;
`;

export const RemarksInputField = styled(InputField)`
  .ui.input {
    margin-bottom: 0;
    input {
      max-width: 22.5rem;
    }
  }
  svg {
    position: relative;
    right: 1.75rem;
    top: 0.6875rem;
  }
`;

export const InstantSpeedSection = styled.div`
  border-radius: 0.125rem;
  background: rgba(122, 238, 234, 0.3);
  padding: 0.25rem;
  svg {
    width: 0.75rem;
    height: 0.75rem;
  }
  .h10 {
    font-size: 0.625rem;
  }
`;

export const StyledSmallInfo = styled.span`
  svg {
    width: 0.75rem;
    height: 0.75rem;
    margin-bottom: 0.1875rem;
  }
`;

export const StyledModalFooter = styled(Text)`
  padding: 0.75rem 1.5rem;
  font-weight: 400;
  border-radius: 0px 0px 0.5rem 0.5rem;
  background: #fbf3e6;
  font-family: 'dm-sans';
  &.light-bg {
    background: white;
    border-top: 1px solid #f0f2f5;
  }
`;

export const SplitRow = styled(Space)`
  & > div:first-child {
    .ui.fluid.input input {
      width: 10.25rem !important;
    }
  }
  .input-field-with-text-label {
    .ui.basic.label {
      max-width: 2.5rem;
    }
    input {
      max-width: 7.5rem !important;
    }
    &.error_border {
      input {
        border-color: rgb(203, 44, 44) !important;
        &:focus {
          border-color: rgb(203, 44, 44) !important;
        }
      }
    }
  }
`;
